import { useContext, useEffect, useState } from 'react';
import clienteAxios from '../../config/axios';
import AuthContext from '../../context/autenticacion/authContext';
import BANCOS_PANAMA from '../../config/bancosPanama';
import { useT } from 'i18n';

const hoy = () => new Date().toISOString().slice(0, 10);
const vacio = { amount: '', bank: '', fecha: hoy(), note: '' };

const Dato = ({ etiqueta, valor }) => {
  const { t } = useT();
  const [copiado, setCopiado] = useState(false);
  const copiar = async () => {
    try { await navigator.clipboard.writeText(valor); setCopiado(true); setTimeout(() => setCopiado(false), 1500); } catch (e) { /* sin permiso de portapapeles */ }
  };
  return (
    <div className="p7-dato">
      <div><span>{etiqueta}</span><strong>{valor}</strong></div>
      <button type="button" className="p7-btn-ghost" onClick={copiar}>{copiado ? t('dep.copiado') : t('dep.copiar')}</button>
    </div>
  );
};

const DepositosACH = ({ onCreado }) => {
  const { t, ts } = useT();
  const { TodosDepositos } = useContext(AuthContext);
  const [banco, setBanco] = useState(null);
  const [form, setForm] = useState(vacio);
  const [archivo, setArchivo] = useState(null);
  const [error, setError] = useState('');
  const [ok, setOk] = useState('');
  const [enviando, setEnviando] = useState(false);

  useEffect(() => {
    clienteAxios.post('/api/client/deposits/ach-panama').then((r) => setBanco(r.data.data)).catch(() => setBanco({}));
  }, []);

  const cambiar = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const elegirArchivo = (e) => {
    const f = e.target.files[0];
    setError('');
    if (!f) { setArchivo(null); return; }
    if (f.size > 4 * 1024 * 1024) { setError(t('dep.achArchivoGrande')); e.target.value = ''; return; }
    if (!['image/jpeg', 'image/png', 'application/pdf'].includes(f.type)) { setError(t('dep.achFormato')); e.target.value = ''; return; }
    setArchivo(f);
  };

  const enviar = async (e) => {
    e.preventDefault();
    setError('');
    if (!archivo) { setError(t('dep.achSinComprobante')); return; }
    const datos = new FormData();
    datos.append('type', '6');
    datos.append('amount', form.amount);
    datos.append('bank', form.bank.trim());
    datos.append('fecha', form.fecha);
    datos.append('note', form.note.trim());
    datos.append('file', archivo);
    setEnviando(true);
    try {
      const r = await clienteAxios.post('/api/client/deposits/create', datos, { headers: { 'Content-Type': 'multipart/form-data', Accept: 'application/json' } });
      setOk(ts(r.data.message) || t('dep.achReportado'));
      setForm({ ...vacio, fecha: hoy() });
      setArchivo(null);
      if (TodosDepositos) TodosDepositos();
    } catch (err) {
      setError(ts(err.response?.data?.message) || t('dep.achNoSePudo'));
    } finally {
      setEnviando(false);
    }
  };

  const configurado = banco && banco.banco && banco.cuenta;

  if (ok) {
    return (
      <div className="p7-empty" role="status">
        <p>{ok}</p>
        <p className="p7-empty-sub">{t('dep.achRevisamos')}</p>
        <div className="p7-wallet-actions" style={{ justifyContent: 'center' }}>
          <button type="button" className="p7-btn-ghost" onClick={() => setOk('')}>{t('dep.achReportarOtro')}</button>
          {onCreado && <button type="button" className="p7-btn-gold" onClick={onCreado}>{t('dep.achVerMis')}</button>}
        </div>
      </div>
    );
  }

  return (
    <div className="p7-ach">
      <section className="p7-ach-col">
        <h4>{t('dep.achPaso1')}</h4>
        {banco === null && <p className="p7-empty-sub">{t('dep.cargandoDatos')}</p>}
        {banco && !configurado && <p className="p7-wallet-error">{t('dep.achSinDatos')}</p>}
        {configurado && (
          <>
            <Dato etiqueta={t('dep.achBanco')} valor={banco.banco} />
            {banco.titular && <Dato etiqueta={t('dep.achTitular')} valor={banco.titular} />}
            <Dato etiqueta={banco.tipo ? t('dep.achCuentaTipo', { tipo: banco.tipo.toLowerCase() }) : t('dep.achCuenta')} valor={banco.cuenta} />
            {banco.nota && <p className="p7-wallet-help">{banco.nota}</p>}
          </>
        )}
        <p className="p7-wallet-help">{t('dep.achAyuda')}</p>
      </section>

      <form className="p7-ach-col p7-form" onSubmit={enviar}>
        <h4>{t('dep.achPaso2')}</h4>

        <label htmlFor="ach-monto">{t('dep.achMonto')}</label>
        <input id="ach-monto" name="amount" type="number" step="0.01" min="1" value={form.amount} onChange={cambiar} placeholder={t('dep.achPhMonto')} required />

        <label htmlFor="ach-banco">{t('dep.achBancoOrigen')}</label>
        <input id="ach-banco" name="bank" list="ach-bancos" value={form.bank} onChange={cambiar} maxLength={50} placeholder={t('dep.achPhBanco')} autoComplete="off" required />
        <datalist id="ach-bancos">
          {BANCOS_PANAMA.map((b) => <option key={b} value={b} />)}
        </datalist>

        <label htmlFor="ach-fecha">{t('dep.achFecha')}</label>
        <input id="ach-fecha" name="fecha" type="date" value={form.fecha} max={hoy()} onChange={cambiar} required />

        <label htmlFor="ach-ref">{t('dep.achReferencia')}</label>
        <input id="ach-ref" name="note" value={form.note} onChange={cambiar} maxLength={60} required />

        <label htmlFor="ach-file">{t('dep.achComprobante')}</label>
        <input id="ach-file" type="file" accept="image/jpeg,image/png,application/pdf" onChange={elegirArchivo} required />

        {error && <div className="p7-wallet-error" role="alert">{error}</div>}

        <button type="submit" className="p7-btn-gold" disabled={enviando}>{enviando ? t('dep.enviando') : t('dep.achReportar')}</button>
      </form>
    </div>
  );
};

export default DepositosACH;
